import React from "react";
import { Stack, Typography } from "@mui/material";
import { HyroTable } from "@hyro-components";
import { PRODUCTS_TABLE_COLUMNS } from "./SubscriptionTab.consts";

const ProductsTable = ({ products }) => {
  const rows = products.map((product, index) => ({
    id: index,
    name: product.name
  }));

  return (
    <Stack gap="12px">
      <Typography variant="subtitle2">
        Products and packages{" "}
        <Typography component="span" variant="subtitle2" color="text.700">
          ({products.length})
        </Typography>
      </Typography>
      <HyroTable
        columns={PRODUCTS_TABLE_COLUMNS}
        rows={rows}
        showPagination={products.length > 0}
        noRowsText="Product data is not yet available. It will appear here once updated."
        noRowsTextSx={{
          maxWidth: 250,
          textAlign: "center"
        }}
        minHeight={250}
      />
    </Stack>
  );
};

export default ProductsTable;
